var _path, _circle, _circle2, _path2, _circle3, _circle4, _path3;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgFami(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 100,
    height: 100,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("svg", _extends({
    fill: "#FFF",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 100 100",
    transform: "matrix(.69 0 0 .69 15.5 15.5)",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M36.705 30.773c12.33 0 15.588 12.746 15.588 19.486a2.598 2.598 0 0 1-2.593 2.597h-.005a2.602 2.602 0 0 1-2.598-2.59c-.001-.364-.07-5.833-2.598-9.898v16.387L43.253 81.18a1.106 1.106 0 0 1-1.092 1.036h-2.338a1.104 1.104 0 0 1-1.092-1.036l-1.247-24.426h-1.559L34.68 81.18a1.105 1.105 0 0 1-1.092 1.036H31.25a1.105 1.105 0 0 1-1.092-1.036l-1.247-24.426V40.367c-2.528 4.064-2.597 9.532-2.598 9.893a2.599 2.599 0 1 1-5.197 0c.001-6.74 3.259-19.487 15.589-19.487z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 36.705,
    cy: 23.629,
    r: 5.845
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 14.367,
    cy: 47.815,
    r: 4.258
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.367 52.855c1.512 0 2.792.322 3.88.865 2.697-2.09 4.29-5.271 4.396-5.503a1.549 1.549 0 1 1 2.817 1.288c-1.09 2.383-3.328 6.1-6.409 8.355v10.604l-.669 13.092a.7.7 0 0 1-.692.658h-1.495a.702.702 0 0 1-.692-.658l-.668-13.092h-.936l-.669 13.095a.7.7 0 0 1-.691.657h-1.496a.7.7 0 0 1-.691-.657l-.668-13.093v-9.849c-1.519 2.443-1.561 5.73-1.562 5.949a1.563 1.563 0 0 1-1.564 1.556A1.558 1.558 0 0 1 5 64.563c0-4.049 1.958-11.708 9.367-11.708zM47.363 49.905c.117-.771 3.043-18.871 15.301-18.871 12.257 0 15.184 18.1 15.301 18.871a2.338 2.338 0 1 1-4.623.71c-.014-.092-.982-5.808-3.664-10.133v3.542l4.424 17.697c.14.559-.213 1.01-.787 1.01h-3.422l-.941 18.447a1.104 1.104 0 0 1-1.092 1.037h-2.338a1.108 1.108 0 0 1-1.094-1.037l-.94-18.448h-1.649l-.94 18.447a1.106 1.106 0 0 1-1.092 1.037h-2.34a1.105 1.105 0 0 1-1.092-1.037l-.941-18.447h-3.422c-.574 0-.926-.451-.787-1.01l4.424-17.697v-3.615C52.94 44.742 52 50.522 51.985 50.614a2.338 2.338 0 0 1-4.622-.709z"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 62.664,
    cy: 23.629,
    r: 5.845
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 84.546,
    cy: 47.815,
    r: 4.258
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M80.094 57.898v-.328c-3.441-2.125-5.714-6.455-6.639-9.046a1.549 1.549 0 1 1 2.917-1.042c.021.059 1.498 4.084 4.358 6.198 1.106-.517 2.369-.824 3.817-.824 7.218 0 9.987 7.545 10.443 11.535a1.55 1.55 0 0 1-1.36 1.713 1.551 1.551 0 0 1-1.716-1.359c-.03-.247-.546-4.331-2.914-6.846v4.584l3.248 8.117c.132.334-.051.604-.409.604h-2.9l-.529 10.355a.702.702 0 0 1-.692.657h-1.524a.7.7 0 0 1-.691-.657l-.527-10.354h-.856l-.528 10.354a.7.7 0 0 1-.691.657h-1.524a.697.697 0 0 1-.69-.657l-.528-10.354h-2.902c-.356 0-.54-.271-.407-.603l3.248-8.117v-4.586h-.004z"
  }))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFami);
export default __webpack_public_path__ + "static/media/FAMI.91e5d7bd.svg";
export { ForwardRef as ReactComponent };